import { useState, type CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MessageCircle, Phone } from 'lucide-react';
import TermsDialog from '@/shared/components/TermsDialog';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useToast } from '@/shared/contexts';
import { HOME_SECTIONS } from './SiteHeader';

// Botao com texto; o hover acende na cor oficial da rede (--brand).
const SOCIALS = [
  { name: 'Discord', href: 'https://discord.gg/n9ccbGhK72', brand: '#5865F2', icon: <MessageCircle size={16} /> },
  { name: 'WhatsApp', href: 'https://chat.whatsapp.com/LFow5zbfZ2ZAfIREYUqo13', brand: '#25D366', icon: <Phone size={16} /> },
  { name: 'Instagram', href: 'https://www.instagram.com/caballibertyep39/', brand: '#E1306C', icon: <Instagram size={16} /> },
  { name: 'Facebook', href: 'https://www.facebook.com/share/1FC1YQ9zq5/?mibextid=wwXIfr', brand: '#1877F2', icon: <Facebook size={16} /> },
];

// hrefBase="/" pra paginas fora da home (cadastro): as ancoras viram /#secao ->
// carregam a home e rolam ate' a secao. Na home fica "" (ancora na mesma pagina).
export function SiteFooter({ hrefBase = '' }: { hrefBase?: string }) {
  const { isLoggedIn } = useAuth();
  const { setOpenVerify } = useToast();
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
    <footer className="footer footer-cols">
      <div className="shell footer-main">
        <div className="footer-about">
          <a className="brand" href={`${hrefBase}#home`}><span>CABAL</span><b>LIBERTY</b></a>
          <p>Mais que um jogo. Uma nova jornada.<br />O primeiro servidor privado EP39 do Brasil.</p>
        </div>

        <div className="footer-col">
          <h4>Acesso rápido</h4>
          <div className="footer-links">
            {HOME_SECTIONS.map((s) => <a key={s.id} href={`${hrefBase}#${s.id}`}>{s.label}</a>)}
            {isLoggedIn ? (
              <Link to="/dashboard">Painel</Link>
            ) : (
              <>
                <button type="button" onClick={() => setOpenVerify(true)}>Entrar</button>
                <Link to="/cadastro">Cadastro</Link>
              </>
            )}
          </div>
        </div>

        <div className="footer-col">
          <h4>Links</h4>
          <div className="footer-links">
            <button type="button" onClick={() => setShowTerms(true)}>Termos de Uso</button>
            {/* a politica de privacidade faz parte do mesmo documento dos termos */}
            <button type="button" onClick={() => setShowTerms(true)}>Privacidade</button>
            <Link to="/dashboard/suporte">Suporte</Link>
          </div>
        </div>

        <div className="footer-col">
          <h4>Comunidade</h4>
          <div className="footer-socials">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                className="social-btn"
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ ['--brand' as string]: s.brand } as CSSProperties}
              >
                {s.icon}<span>{s.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="shell">
          <p>© {new Date().getFullYear()} Cabal Liberty — Todos os direitos reservados.</p>
          <p>Imagens e marcas pertencem aos seus respectivos donos. Sem qualquer afiliação com ESTsoft Corp., ESTsoft Inc., NBird LLC, SDO, SNDO ou SNDA.</p>
        </div>
      </div>
    </footer>
    {/* fora do <footer>: as regras .footer p do tema pegariam o texto do modal */}
    <TermsDialog open={showTerms} onClose={() => setShowTerms(false)} />
    </>
  );
}
